import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'precision',
  standalone: true,
})
export class PrecisionPipe implements PipeTransform {
  /**
   * `trimZeros` drops trailing fractional zeros, so with precision 5
   * 0.5 renders as "0.5" rather than "0.50000".
   */
  transform(
    value: string | number | null | undefined,
    precision = 2,
    trimZeros = false,
  ): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    const num = Number(value);
    if (isNaN(num)) {
      return '';
    }
    const fixed = num.toFixed(precision);
    if (!trimZeros || !fixed.includes('.')) {
      return fixed;
    }
    const trimmed = fixed.replace(/\.?0+$/, '');
    return trimmed === '-0' ? '0' : trimmed;
  }
}
